import { useTranslation } from 'react-i18next';

import {
  Button,
  Form,
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  TextAreaInput,
  TextInput,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import {
  DeleteContainer,
  FormListContent,
  MainContainer,
} from 'src/pages/jobs/components/job-form/job-form.styles';

const JobDescriptionsFormList = ({ isEdit }: { isEdit?: boolean }) => {
  const { t } = useTranslation(['common', 'jobs']);

  return (
    <MainContainer>
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {t('jobs:labels.jobAdvertisementDescription')}
      </Typography>
      <Form.Item name="advertisementDescription" label={t('jobs:labels.jobDescription')}>
        <TextAreaInput
          showCount
          maxLength={2000}
          placeholder={t('products:planList.createPlan.placeholders.writeDescription')}
        />
      </Form.Item>
      <Form.List name="neededSkills" initialValue={isEdit ? undefined : ['']}>
        {(fields, { add, remove }) => (
          <FormListContent isIcon={fields.length > 1}>
            {fields.map(field => (
              <DeleteContainer key={field.key} isIcon={fields.length > 1}>
                <Form.Item name={[field.name]} label={t('jobs:labels.neededSkills')}>
                  <TextInput placeholder={t('jobs:labels.teamPlayer')} maxLength={100} />
                </Form.Item>
                {fields.length > 1 && (
                  <Icon
                    icon={ICONS.trash}
                    size={22}
                    rightMargin={false}
                    color={PLATFORM_THEME_COLORS.tone.red}
                    onClick={() => remove(field.name)}
                  />
                )}
              </DeleteContainer>
            ))}
            <Button
              type="text"
              icon={ICONS.plus}
              iconColor={PLATFORM_THEME_COLORS.primary.blue}
              onClick={() => add()}
            >
              {t('jobs:buttons.addSkill')}
            </Button>
          </FormListContent>
        )}
      </Form.List>
    </MainContainer>
  );
};

export default JobDescriptionsFormList;
